import { RoleModel } from "./role";
import { PermissionEnum } from "@vini-wine/core-enums";
import { PermissionDto } from "@vini-wine/core-dtos";

export interface PermissionModel {
  // available includes
  roles?: RoleModel[];

  // transform
  id: PermissionEnum;
}

export const createPermissionDtoFromAdminPermissionModel = (
  permission: PermissionModel,
): PermissionDto => {
  return {
    id: permission.id,
    roles: permission.roles,
  };
};
